module.exports = __webpack_public_path__ + "static/media/bg-text.3346e89f.png";